import { Input, InputPhone, Label } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import type { ProfileFormProps } from './profile-form.type'

import styles from './profile-form.module.css'

export const ProfileForm = ({
  onChangeValues,
  values,
  errors,
}: ProfileFormProps) => {
  const { t } = useTranslation('screenQuotationRequestList')

  const onHandleValues = (key: string, value: string | number) => {
    onChangeValues({ ...values, [key]: value })
  }

  return (
    <div className={styles.core}>
      <div>
        <Label>{t('profileFormEmailLabel')}</Label>
        <Input
          placeholder={t('profileFormEmailPlaceholder')}
          value={values?.email}
          onChange={(newValue) => onHandleValues('email', newValue)}
          error={errors?.email}
        />
      </div>

      <div>
        <Label>{t('profileFormCompanyNameLabel')}</Label>
        <Input
          placeholder={t('profileFormCompanyNamePlaceholder')}
          value={values?.companyName}
          onChange={(newValue) => onHandleValues('companyName', newValue)}
          error={errors?.companyName}
        />
      </div>

      <div>
        <Label>{t('profileFormPhoneLabel')}</Label>
        <InputPhone
          placeholder={t('profileFormPhonePlaceholder')}
          value={values?.phone}
          onChange={(newValue) => onHandleValues('phone', newValue)}
          error={errors?.phone}
        />
      </div>
    </div>
  )
}
